import { StatItemWrapper } from "@/components/wrappers";

interface StatItemProps {
  count: number;
  title: string;
  icon: React.ReactNode;
  color: string;
  bgColor: string;
}

const StatItem = ({ count, title, icon, color, bgColor }: StatItemProps) => {
  return (
    <StatItemWrapper color={color} bgColor={bgColor}>
      <header>
        <span className="count">{count}</span>
        <span className="icon">{icon}</span>
      </header>
      <h5 className="title">{title}</h5>
    </StatItemWrapper>
  );
};

export default StatItem;
